import { Box, Typography } from "@mui/material";
import { colors } from "../../ui/colors";
import { CalendarMode } from "../types";
import { useCalendarDateSelectorState } from "../states/useCalendarDateSelector";

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

const MODE_LABELS: Record<CalendarMode, string> = {
  day: "Day",
  week: "Week",
  month: "Month",
  quarter: "Quarter",
  year: "Year",
};

export function CalendarSelectionSummary() {
  const { range, mainMode } = useCalendarDateSelectorState();

  if (!range.start) return null;

  const start = range.start;
  const end = range.end || range.start;
  const isSingleDay =
    start.getFullYear() === end.getFullYear() &&
    start.getMonth() === end.getMonth() &&
    start.getDate() === end.getDate();

  return (
    <Box sx={{ width: "100%", py: 0.5 }}>
      <Typography
        align="center"
        sx={{
          color: colors.orange.base,
          fontWeight: 900,
          fontSize: 10,
          mb: 2,
          textTransform: "uppercase",
          letterSpacing: 1,
        }}
      >
        {MODE_LABELS[mainMode]} Selection
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: isSingleDay ? 0 : 5,
        }}
      >
        <Box textAlign="center">
          {!isSingleDay && <Typography sx={{ color: "var(--fx-surface-texttertiary, #94A3B8)", fontWeight: 900, fontSize: 10, mb: 0.5 }}>FROM</Typography>}
          <Typography
            sx={{
              fontSize: isSingleDay ? 46 : 34,
              fontWeight: 900,
              color: "var(--fx-surface-text, #0F172A)",
              letterSpacing: -1,
              lineHeight: 1.1,
            }}
          >
            {start.getDate()}
          </Typography>
          <Typography
            sx={{
              fontSize: isSingleDay ? 12 : 11,
              fontWeight: 800,
              color: "var(--fx-surface-textsecondary, #64748B)",
              mt: 0.5,
            }}
          >
            {MONTHS[start.getMonth()].slice(0, 3)} {start.getFullYear()}
          </Typography>
        </Box>

        {!isSingleDay && (
          <>
            <Box sx={{ height: 45, width: "2px", bgcolor: "var(--fx-surface-muted, #F1F5F9)", mx: 1 }} />

            <Box textAlign="center">
              <Typography sx={{ color: "var(--fx-surface-texttertiary, #94A3B8)", fontWeight: 900, fontSize: 10, mb: 0.5 }}>TO</Typography>
              <Typography
                sx={{
                  fontSize: 38,
                  fontWeight: 900,
                  color: "var(--fx-surface-text, #0F172A)",
                  letterSpacing: -1,
                  lineHeight: 1.1,
                }}
              >
                {end.getDate()}
              </Typography>
              <Typography
                sx={{
                  fontSize: 11,
                  fontWeight: 800,
                  color: "var(--fx-surface-textsecondary, #64748B)",
                  mt: 0.5,
                }}
              >
                {MONTHS[end.getMonth()].slice(0, 3)} {end.getFullYear()}
              </Typography>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
}
